import { render, staticRenderFns } from "./centerSwiper.vue?vue&type=template&id=3059c5a3&scoped=true&"
import script from "./centerSwiper.vue?vue&type=script&lang=js&"
export * from "./centerSwiper.vue?vue&type=script&lang=js&"
import style0 from "./centerSwiper.vue?vue&type=style&index=0&id=3059c5a3&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3059c5a3",
  null
  
)

export default component.exports